import { ReactSortable } from 'react-sortablejs';
import { Redirect, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import ContentWrapper from '../../layouts/partials/ContentWrapper';
import SidebarWrapper from '../../layouts/partials/SidebarWrapper';
import TableWrapper from '../../layouts/partials/TableWrapper';
import ObjectRow from './partials/ObjectRow';
import { replaceFavoriteList, selectFavoriteListByIdWithObjects, selectIPadFavoriteListById } from '../../../../redux/modules/favoritesSlice';
import PrivateLayout from '../../layouts/PrivateLayout';
import useTranslation from '../../../../hooks/useTranslations';
import { setFavoriteList } from '../../../../redux/modules/appSlice';

const FavoriteListScreen = () => {
	const t = useTranslation();

	const { favoriteListId } = useParams();
	const dispatch = useDispatch();

	const favoriteList = useSelector((state) => selectFavoriteListByIdWithObjects(state, favoriteListId));
	const iPadFavoriteList = useSelector((state) => selectIPadFavoriteListById(state, favoriteListId));

	useEffect(() => {
		if (favoriteListId && favoriteList) {
			dispatch(setFavoriteList({ favoriteList }));
		} else if (favoriteListId && iPadFavoriteList) {
			dispatch(setFavoriteList({ favoriteList: iPadFavoriteList }));
		} else {
			dispatch(setFavoriteList({ favoriteList: null }));
		}
		return () => {
			dispatch(setFavoriteList({ favoriteList: null }));
		};
	}, [favoriteListId, favoriteList, iPadFavoriteList, dispatch]);

	if (!favoriteList && !iPadFavoriteList) {
		return <Redirect to="/favorites" />;
	}

	const favList = favoriteList ?? iPadFavoriteList;

	const setNewObjectsOrder = (params) => {
		const updatedFavoriteList = { ...favList, objects: params, objectIds: params.map((obj) => obj.id) };
		dispatch(replaceFavoriteList({ favoriteList: updatedFavoriteList }));
	};

	const breadcrumb = [
		{ route: 'favorites', translationKey: 'favorites_headline' },
		{ route: `favorites/${favList.id}`, translationKey: favList.title },
	];

	return (
		<PrivateLayout customTree={breadcrumb}>
			<SidebarWrapper title={favList.title} customTree={breadcrumb} />
			<ContentWrapper title={favList.objects.length === 0 ? t('search_no_documents_found') : ''}>
				{favList.objects.length > 0 && (
					<TableWrapper>
						<ReactSortable
							list={favList.objects}
							setList={(params) => setNewObjectsOrder(params)}
							className="flex flex-col gap-5"
							ghostClass="ghost-class"
							handle=".drag-control"
						>
							{favList.objects.map((object) => <ObjectRow key={object.id} object={object} isDraggable={!iPadFavoriteList} />)}
						</ReactSortable>
					</TableWrapper>
				)}
			</ContentWrapper>
		</PrivateLayout>
	);
};

export default FavoriteListScreen;
